/** Shared IMP master dropdown options (Add / Edit / Excel). */

export const DOSAGE_FORM_OPTIONS = [
  { value: "", label: "Select dosage form" },
  { value: "Tablet", label: "Tablet" },
  { value: "Capsule", label: "Capsule" },
  { value: "Injection", label: "Injection" },
  { value: "Solution for Injection", label: "Solution for Injection" },
  { value: "Solution for Infusion", label: "Solution for Infusion" },
  { value: "Oral Solution", label: "Oral Solution" },
  { value: "Oral Suspension", label: "Oral Suspension" },
  { value: "Powder for Injection", label: "Powder for Injection" },
  { value: "Powder for Oral Solution", label: "Powder for Oral Solution" },
  { value: "Pre-filled Syringe", label: "Pre-filled Syringe" },
  { value: "Cream", label: "Cream" },
  { value: "Gel", label: "Gel" },
  { value: "Ointment", label: "Ointment" },
  { value: "Transdermal Patch", label: "Transdermal Patch" },
  { value: "Inhalation Powder", label: "Inhalation Powder" },
  { value: "Metered Dose Inhaler", label: "Metered Dose Inhaler" },
  { value: "Nebuliser Solution", label: "Nebuliser Solution" },
  { value: "Sublingual Tablet", label: "Sublingual Tablet" },
  { value: "Chewable Tablet", label: "Chewable Tablet" },
  { value: "Dispersible Tablet", label: "Dispersible Tablet" },
  { value: "Effervescent Tablet", label: "Effervescent Tablet" },
  { value: "Extended Release Tablet", label: "Extended Release Tablet" },
  { value: "Modified Release Capsule", label: "Modified Release Capsule" },
  { value: "Granules", label: "Granules" },
  { value: "Suppository", label: "Suppository" },
  { value: "Nasal Spray", label: "Nasal Spray" },
  { value: "Eye Drops", label: "Eye Drops" },
  { value: "Other", label: "Other" },
];

export const ROUTE_OPTIONS = [
  { value: "", label: "Select route" },
  { value: "Oral", label: "Oral" },
  { value: "Intravenous", label: "Intravenous" },
  { value: "Intramuscular", label: "Intramuscular" },
  { value: "Subcutaneous", label: "Subcutaneous" },
  { value: "Topical", label: "Topical" },
  { value: "Transdermal", label: "Transdermal" },
  { value: "Inhalation", label: "Inhalation" },
  { value: "Sublingual", label: "Sublingual" },
  { value: "Buccal", label: "Buccal" },
  { value: "Rectal", label: "Rectal" },
  { value: "Vaginal", label: "Vaginal" },
  { value: "Intranasal", label: "Intranasal" },
  { value: "Ophthalmic", label: "Ophthalmic" },
  { value: "Otic", label: "Otic" },
  { value: "Intradermal", label: "Intradermal" },
  { value: "Intrathecal", label: "Intrathecal" },
  { value: "Other", label: "Other" },
];

export const STRENGTH_UNIT_OPTIONS = [
  { value: "", label: "Select unit" },
  { value: "mg", label: "mg" },
  { value: "g", label: "g" },
  { value: "mcg", label: "mcg" },
  { value: "ng", label: "ng" },
  { value: "mL", label: "mL" },
  { value: "L", label: "L" },
  { value: "mg/mL", label: "mg/mL" },
  { value: "mcg/mL", label: "mcg/mL" },
  { value: "g/mL", label: "g/mL" },
  { value: "mg/5 mL", label: "mg/5 mL" },
  { value: "mcg/dose", label: "mcg/dose" },
  { value: "mg/dose", label: "mg/dose" },
  { value: "IU", label: "IU" },
  { value: "IU/mL", label: "IU/mL" },
  { value: "units/mL", label: "units/mL" },
  { value: "%", label: "%" },
  { value: "% w/w", label: "% w/w" },
  { value: "% w/v", label: "% w/v" },
  { value: "mmol", label: "mmol" },
  { value: "mmol/mL", label: "mmol/mL" },
  { value: "mEq", label: "mEq" },
  { value: "mEq/mL", label: "mEq/mL" },
  { value: "Other", label: "Other" },
];

export const TEMP_UNIT_OPTIONS = [
  { value: "", label: "Select unit" },
  { value: "C", label: "°C" },
  { value: "F", label: "°F" },
];

/** Merge static options with session extras + current saved value (for edit/custom). */
export function mergeLookupOptions(baseOptions, extras = [], currentValue = "") {
  const list = Array.isArray(baseOptions) ? baseOptions : [];
  const placeholder =
    list.find((o) => String(o?.value ?? "") === "") || {
      value: "",
      label: "Select...",
    };
  const byKey = new Map();
  const push = (opt) => {
    const value = String(opt?.value ?? "").trim();
    if (!value) return;
    const key = value.toLowerCase();
    if (!byKey.has(key)) {
      byKey.set(key, {
        value,
        label: String(opt?.label || value).trim() || value,
      });
    }
  };
  list.forEach(push);
  (Array.isArray(extras) ? extras : []).forEach(push);
  const current = String(currentValue || "").trim();
  if (current) push({ value: current, label: current });
  return [placeholder, ...Array.from(byKey.values())];
}
